"use client";
import { useEffect } from "react";

export default function AppPaymentSuccess() {

  useEffect(() => {
    // Redirect to app if on mobile
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      window.location.href = "sellraze://app-payment-success" + window.location.search;
    }
  }, []);

  return (
    <div>
      <h1>Redirecting to app...</h1>
    </div>
  );
}
